import gql from 'graphql-tag';
import * as i0 from "@angular/core";
import * as i1 from "../shared/services/graph-qlclient.service";
export class SesionActivaUsuarioService {
    constructor(client) {
        this.client = client;
    }
    obtenerTodaSesionesActivas(inputParams, callback) {
        this.client.query({
            query: gql `
        query ($paginaActual: Int!, $cantidadRegistrosPorPagina: Int!) {
          sesion_activa_usuario
          {
            obtenerTodasSesionesActivas(paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina)
            {
              mensajes
              {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                registros {
                  token_refresco
                  rut_usuario
                  fecha_creacion
                  fecha_ultima_actividad
                  fecha_expiracion
                  user_agent
                  ip_address
                  nombreUsuario
                  navegador
                  sistemaOperativo
                  tipoDispositivo
                }
              }
            }
          }
        }
      `,
            variables: inputParams,
            fetchPolicy: 'no-cache'
        }, (response) => {
            const notificacion = response.data.sesion_activa_usuario.obtenerTodasSesionesActivas;
            callback(notificacion);
        });
    }
    eliminarSesion(inputParams, callback) {
        this.client.mutate({
            mutation: gql `
        mutation ($entidad: sesion_activa_usuarioInputType) {
          sesion_activa_usuario
          {
            eliminar(entidad: $entidad)
            {
              mensajes
              {
                codigo
                contexto
                texto
                tipo
              }
            }
          }
        }
      `,
            variables: inputParams,
        }, (response) => {
            const mensajes = response.data.sesion_activa_usuario.eliminar.mensajes;
            callback(mensajes);
        });
    }
}
SesionActivaUsuarioService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function SesionActivaUsuarioService_Factory() { return new SesionActivaUsuarioService(i0.ɵɵinject(i1.GraphQLClient)); }, token: SesionActivaUsuarioService, providedIn: "root" });
